import AddEditResource from "./AddEditResource/AddEditResource";
import AddEditSchoolPoc from "./AddEditSchoolPoc/AddEditSchoolPoc";
import AddEditLabSetup from "./AddEditLabSetup/AddEditLabSetup";

const LabInformation = () => {

  return (
    <div className="bg-white p-5">
      <AddEditSchoolPoc />
      <AddEditResource /> 
      <AddEditLabSetup />    
    </div>
  );
};

export default LabInformation;
